import * as React from 'react';
import { Page } from '~/components/about-page/about-page';

const AboutPage: React.FC = () => <Page />;

export default AboutPage;
